import {
  differenceInCalendarDays,
  isValid,
  parseISO,
  startOfDay,
} from 'date-fns'

export function parseDate(dateValue: string | Date): Date | null {
  const parsed = typeof dateValue === 'string' ? parseISO(dateValue) : dateValue
  return isValid(parsed) ? parsed : null
}

export function toUtcCalendarDay(dateValue: string | Date): number | null {
  const parsed = parseDate(dateValue)
  if (!parsed) {
    return null
  }

  return Date.UTC(
    parsed.getFullYear(),
    parsed.getMonth(),
    parsed.getDate(),
  )
}

export function getDaysUntilDeparture(rawDepartureDate?: string, now: Date = new Date()): number | null {
  if (!rawDepartureDate) {
    return null
  }

  const departure = parseISO(rawDepartureDate)
  if (!isValid(departure)) {
    return null
  }

  const days = differenceInCalendarDays(startOfDay(departure), startOfDay(now))

  if (days <= 0) {
    return null
  }

  return days
}

export function isActiveUpcomingBooking(
  rawDepartureDate?: string,
  isCancelled = false,
  now: Date = new Date(),
): boolean {
  return !isCancelled && getDaysUntilDeparture(rawDepartureDate, now) !== null
}

export function isOnHolidays(
  rawDepartureDate?: string,
  rawReturnDate?: string,
  now: Date = new Date(),
): boolean {
  if (!rawDepartureDate) {
    return false
  }

  const departure = parseISO(rawDepartureDate)
  if (!isValid(departure)) {
    return false
  }

  const today = startOfDay(now)
  const departureDay = startOfDay(departure)

  if (departureDay > today) {
    return false
  }

  if (!rawReturnDate) {
    return true
  }

  const returnDate = parseISO(rawReturnDate)
  if (!isValid(returnDate)) {
    return false
  }

  return startOfDay(returnDate) >= today
}

export function isActiveBooking(
  rawDepartureDate?: string,
  rawReturnDate?: string,
  isCancelled = false,
  now: Date = new Date(),
): boolean {
  return isActiveUpcomingBooking(rawDepartureDate, isCancelled, now)
    || (!isCancelled && isOnHolidays(rawDepartureDate, rawReturnDate, now))
}
